import { render, staticRenderFns } from "./PDFReturnToTop.vue?vue&type=template&id=3cf719ba"
import script from "./PDFReturnToTop.vue?vue&type=script&lang=ts"
export * from "./PDFReturnToTop.vue?vue&type=script&lang=ts"
import style0 from "./PDFReturnToTop.vue?vue&type=style&index=0&id=3cf719ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports